import {
  Component, OnInit, Inject, KeyValueDiffer,
  Input, TemplateRef, ViewChild, Output,
  EventEmitter, AfterViewInit, SimpleChanges, OnDestroy, ElementRef
} from '@angular/core';
import { DOCUMENT, DatePipe } from '@angular/common';
import { MsalService } from '@azure/msal-angular';
import { Router, NavigationExtras } from '@angular/router';
import { UserSessionService } from '../services/usersession.service';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { SwitchStoreComponent } from '../switch-store/switch-store.component';
import { ILoggedInUser } from '../Shared/models/ProspectModel';
import { Observable, Subject } from 'rxjs';
import {
  INewsModel,
} from '../Shared/interface';
import { GeneralService } from '../services/general.service';
import {
  ToolbarService,
  LinkService,
  ImageService,
  HtmlEditorService
} from '@syncfusion/ej2-angular-richtexteditor';
import { twoWayService } from '../services/operations/two-way-text.service';
import {
  ISendSMSLogsResponse,
  ISendSmsResponse,
  IRecieveSMSListResponse,
  IMarkAsReadResponse,
  IPhoneSystemTypeModel,
  IMailServerSettingModel
} from '../Shared/interface2';
import { ToastrService } from 'ngx-toastr';
import 'rxjs/add/observable/interval';
import { DataService } from '../facilityOperations/facOps-dashboard/data.service';
import { CustomerService } from '../services/operations/customer.service';
import { IDashboardDetails } from '../Shared/models/CustomerModel';
import { DashboardService } from '../services/operations/dashboard.service';
import { Newsservice } from '../services/News.service';
import { environment } from '../../environments/environment';
import { CacheService } from '../services/cache.service';
import { ETransactionTypes, EUserFunctions } from '../Shared/enum';
import { debounceTime } from 'rxjs/operators';
import { LetterAndNoticesService } from '../services/letterAndNotices.service';
@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, DatePipe]
})
export class TopBarComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() storeInfoFacId: number = 0;
  @Input() isQuickStart: boolean = false;
  @Input() isStopLoader: boolean = false;
  @Input() isPaymentInProcess: boolean = false;
  @Input() isMarketing: boolean = false;
  @Input() isMarketingnews: boolean = false;
  @Input() isMarketingtenantmap: boolean = false;
  @Output() storeChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() emptystore: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('storeNameLabel', { static: false }) storeNameLabel: HTMLElement;
  @ViewChild('scrollMe', { static: false }) private myScrollContainer: ElementRef;
  @ViewChild(SwitchStoreComponent, { static: true }) private SwitchStoreComponent: SwitchStoreComponent;
  private receiveSMSInterval = environment.receiveSMSIntervalInMinute;
  public storeNameChange: Subject<object> = new Subject();
  public getnewsSubject: Subject<object> = new Subject();
  public enableRingCentralWidget = environment.enableRingCentralWidget;
  newsInfo: INewsModel;
  modalRef: BsModalRef;
  defaultStoreName: string;
  userSessionStores = [];
  lastAccessedFacility: number;
  private userSessinDiffer: KeyValueDiffer<string, any>;
  switchStoreOption: boolean;
  isFullScreen: Boolean;
  loggedIn: Boolean;
  isAdmin: Boolean;
  public newslist: any;
  private UserSessionData;
  loggedInUserDetails: ILoggedInUser;
  UserFname: string;
  UserLname: string;
  smsCount;
  smsLists;
  tenantname;
  tenantnumber;
  tenantid;
  public
  smsfacid;
  toDeleteOneList;
  sub;
  filteredLogs;
  isEnableCampaignTracker: Boolean;
  isEnableCallTracker: Boolean;
  public rteValue: string = ` `;
  public toolbarConfig: object = {
    items: []
  };
  // @ViewChild('defaultRTE', { static: false })
  @Input() AdminOrOps: string = 'Operation';
  lettertypelist: any;
  LetterTemplateDetails: any;
  leaseNo: any;
  facilityId: any;
  reservationNumber: any;
  reservationFacilityId: any;
  inquiryNumber: any;
  inquiryFacilityId: any;
  selectedTypeId: any;
  sendSMSAlert: any;
  transactionTypeId: any;

  get loaderIcon(): Promise<boolean> {
    return this._loaderIcon;
  }

  letterGroupBYNameWise: any = [];
  letterGroupByNameList: any = [];
  NotificationLettersInvoicesDetailByName: boolean = false;
  letterGroupByNameListGrouped: any = [];
  NotificationLettersInvoicesDetailByNameDisplay: boolean = false;
  IsRemoveAllGroupByName: boolean = false;
  facilitywiseRental;
  facilitywiseReservation;
  facilitywiseProspect;
  facilityLevelLogo: any = '';
  compSettingSearchDetails;
  facilityDayendSetting;
  facilityLateAndLienSetting;
  permissionQuickStart = false;
  viewRightTenantMapping = false;
  companySettingBrandingLogo: any;

  constructor(private router: Router,

    @Inject(DOCUMENT) private document: any, public authService: MsalService,
    private userSessionService: UserSessionService,
    private modalService: BsModalService,
    private generalService: GeneralService,
    private twoWayService: twoWayService,
    private toastr: ToastrService,
    private data: DataService,
    private customerService: CustomerService,
    private dashboardService: DashboardService,
    private Newsservice: Newsservice,
    private cacheService: CacheService,
    private letterAndNoticesService: LetterAndNoticesService,
    private datepipe: DatePipe,
  ) {
    this.tempRouter = this.router;
    this.userSessionService.userDetailsChange.subscribe((userData: ILoggedInUser) => {
      if (this.AdminOrOps === 'Admin') {
        this.isAdmin = true;
      } else if (this.AdminOrOps === 'Operation') {
        this.isAdmin = false;
      }
      this.UserFname = userData.UserDetails.FirstName;
      this.UserLname = userData.UserDetails.LastName;
      if (this.userSessionService != undefined) {
        this.newslist = this.userSessionService.newslist;
      }
      this.userSessionStores = userData.UserDetails.StorageFacilities;

      if (userData.UserDetails.StoreGroupUsers.length > 0) {
        let stores = userData.UserDetails.StoreGroupUsers.map(sg => sg.StorageFacilities);
        stores.forEach(as => {
          as.forEach(s => {
            let store = this.userSessionStores.find(st => st.Id == s.Id)
            if (store == null || store == undefined) {
              this.userSessionStores.push(s)
            }
          });
        })
      }

      this.lastAccessedFacility = userData.UserDetails.LastAccessedFacility;
      if (userData.GeolocationBasedLogin || userData.IPBasedLogin) {
        this.isGeoLocationBasedLogIn = true;
        this.showStoreNameModalForGeoLacationLogin.show();
      }
      if (this.lastAccessedFacility != 0 && this.isAdmin === false) {
        this.getFacilitylevellogo();
        if (this.userSessionService.smsActivated) {
          this.GetSMSIntervalInMinute();
        }
      }
      if (this.isAdmin === true) {
        this.switchStoreOption = false;
      } else if (userData.UserGroupCallCenter === true) {
        this.switchStoreOption = false;
        this.lastAccessedFacility = 0;
        this.locationObj = { Id: this.lastAccessedFacility, Name: '' };
        this.storeNameChange.next(this.locationObj);
        this.storeChange.emit(this.locationObj);
      } else if (userData.UserDetails.StorageFacilities.length <= 1) {
        this.switchStoreOption = false;
      } else {
        this.switchStoreOption = true;
      }

      if ((this.lastAccessedFacility != 0 && this.lastAccessedFacility)
        && userData.UserDetails.StorageFacilities.length > 0 && this.isAdmin === false && userData.UserGroupCallCenter === false) {
        if (userData.UserDetails.StorageFacilities.findIndex(o => o.Id === this.lastAccessedFacility) != -1) {
          const storeName = userData.UserDetails.StorageFacilities.find(o => o.Id === this.lastAccessedFacility).Name;
          this.locationObj = { Id: this.lastAccessedFacility, Name: storeName };
          this.storeNameChange.next(this.locationObj);
          this.storeChange.emit(this.locationObj);
        } else {
          this.lastAccessedFacility = 0;
        }
      }

      if (this.isAdmin === false && userData.UserGroupCallCenter === false && (!this.lastAccessedFacility) && userData.GeolocationBasedLogin === false) {
        if (userData.UserDetails.StorageFacilities.length > 0) {
          this.SwitchStoreComponent.openSwitchstoreModal();
        }
      }

      if (userData.UserDetails.StorageFacilities.length == 0 && this.isAdmin === false && userData.UserGroupCallCenter === false && userData.GeolocationBasedLogin == false) {
        this.SwitchStoreComponent.openemptystoreModel();
      }
      this.UserFname = userData.UserDetails.FirstName;
      this.UserLname = userData.UserDetails.LastName;
    });
    this.userSessionService.mailSettingChange.subscribe((data) => {
      if (this.lastAccessedFacility != 0 && this.isAdmin === false) {
        if (this.userSessionService.smsActivated) {
          this.GetSMSIntervalInMinute();
        }
      }
    });
  }

  set setCustimerInfoStorage(value) {
    this.data.custimerInfoStorage = value;
  }

  set noticeFollowup(value) {
    this.data.followUpsData = value;
  }

  set setNotificationInfoStorage(value) {
    this.data.notification = value;
  }

  get getNotificationInfoStorage() {
    return this.data.notification;
  }

  phoneSystemType = '0';
  smsIntervalInMinute = 0;
  newscontent: string;
  locationObj = { Id: 0, Name: '' };
  localLocationObj = { Id: 0, Name: '' };
  smstext = '';
  logs;
  SysDate = new Date();
  customerDashboardDetails;
  countryCode;
  fullphonenumber;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp',
    enableHtml: true,
  };

  tempRouter;
  isGeoLocationBasedLogIn = false;
  @ViewChild('showStoreNameModalForGeoLacationLogin', { static: true }) showStoreNameModalForGeoLacationLogin: ModalDirective;
  dayLettersAndNoticeslist = [];
  currentLetterAndNotices: any;
  currentDayEndReports: any;
  @Input() isESignature: string;

  private _loaderIcon: Promise<boolean>;
  elem;
  @ViewChild('DeleteConversactionModal', { static: true }) deleteConv: TemplateRef<any>;
  @ViewChild('NewsModal', { static: true }) newspop: TemplateRef<any>;

  MessageList = true;
  MessageDetail = false;

  setLoaderIcon(value: boolean): void {
    if (value) {
      if (!this.isPaymentInProcess) {
        this._loaderIcon = Promise.resolve(value);
      }
    } else {
      this._loaderIcon = Promise.resolve(value);
    }
  }

  logout() {
    localStorage.removeItem('beareerToken');
    this.cacheService.clearAllCache().subscribe(() => {
      this.authService.logout();
    });
  }

  ngOnInit() {
    this.selectedTypeId = null;
    this.setLoaderIcon(true);
    if (this.AdminOrOps === 'Admin') {
      this.isAdmin = true;
      let defaultPhoneSystem: IPhoneSystemTypeModel;
      this.userSessionService.defaultPhoneSystem = defaultPhoneSystem;
    } else if (this.AdminOrOps === 'Operation') {
      this.isAdmin = false;
      this.GetPhoneSystemType();
    }

    if (this.userSessionService.userSessionData) {
      let storeName;
      this.UserFname = this.userSessionService.userSessionData.FirstName;
      this.UserLname = this.userSessionService.userSessionData.LastName;
      this.userSessionStores = this.userSessionService.userSessionData.StorageFacilities;

      if (this.userSessionService.userSessionData.StoreGroupUsers.length > 0) {
        let stores = this.userSessionService.userSessionData.StoreGroupUsers.map(sg => sg.StorageFacilities);
        stores.forEach(as => {
          as.forEach(s => {
            // Check store exists or not
            let store = this.userSessionStores.find(st => st.Id == s.Id)
            if (store == null || store == undefined) {
              this.userSessionStores.push(s)
            }
          });
        })
      }
      if (this.userSessionService.userSessionData.StorageFacilities.findIndex(o => o.Id == this.userSessionService.userSessionData.LastAccessedStoreId) !== -1) {
        this.lastAccessedFacility = this.userSessionService.userSessionData.LastAccessedStoreId;
      } else {
        this.lastAccessedFacility = 0;
      }
      if (this.userSessionService.userSessionData.UserGroup.GeolocationBasedLogin || this.userSessionService.userSessionData.UserGroup.IPBasedLogin) {
        this.isGeoLocationBasedLogIn = true;
      }
      if (this.userSessionService.userSessionData.StorageFacilities.find(o => o.Id == this.userSessionService.userSessionData.LastAccessedStoreId)) {
        storeName = this.userSessionService.userSessionData.StorageFacilities.find(o => o.Id == this.userSessionService.userSessionData.LastAccessedStoreId).Name;
      }
      this.locationObj = { Id: this.lastAccessedFacility, Name: storeName };

      if (this.userSessionService.userSessionData && this.userSessionService.userSessionData.UserId != 0 && !this.lastAccessedFacility) {
        if (!this.isAdmin && this.userSessionService.userSessionData.UserGroup.CallCenterGroup === false && (!this.lastAccessedFacility) &&
          this.userSessionService.userSessionData.UserGroup.GeolocationBasedLogin === false) {
          if (this.userSessionService.userSessionData.StorageFacilities.length > 0) {
            this.SwitchStoreComponent.openSwitchstoreModal();
          }
        }
      }
      if (this.lastAccessedFacility) {
        const date = new Date();
        date.setHours(0, 0, 0, 0);
        this.UserFname = this.generalService.UserFname;
        this.UserLname = this.generalService.UserLname;
        if (this.userSessionService.IsNewList == 0) {
          this.userSessionService.getNewItem(this.lastAccessedFacility);
        }
        if (this.userSessionService != undefined) {
          this.newslist = this.userSessionService.newslist;
        }

        if (!this.userSessionService.isCallcenterAgent) {
          this.localLocationObj = JSON.parse(JSON.stringify(this.locationObj));
        }
        this.storeChange.emit(this.locationObj);
      }
      if (!this.isAdmin) {
        this.getFacilitylevellogo();
      }
      this.storeNameChange.subscribe(val => {
        if (this.userSessionService.smsActivated) {
          if (this.sub) {
            this.sub.unsubscribe();
            this.sub = undefined;
          }
          this.GetSMSIntervalInMinute();
        }
        this.localLocationObj = JSON.parse(JSON.stringify(val));
        if (this.lastAccessedFacility) {
          const date = new Date();
          date.setHours(0, 0, 0, 0);
          const datepipe = new DatePipe('en');
          const startdate = datepipe.transform(date, 'MM/dd/yyyy');
          this.getnewslist(this.lastAccessedFacility, startdate);
        }
      });

      this.isFullScreen = false;
      this.elem = document.documentElement;
      if (this.lastAccessedFacility != 0 && this.isAdmin === false) {
        if (this.userSessionService.smsActivated) {
          this.GetSMSIntervalInMinute();
        }
      }
      this.setLoaderIcon(false);
    }

    if (this.userSessionService.companySettingDetails != undefined) {
      this.compSettingSearchDetails = this.userSessionService.companySettingDetails.CustomSearchFields;
      this.companySettingBrandingLogo = this.userSessionService.companySettingDetails.General.BrandingLogoFilePath;
    } else {
      this.userSessionService.companysettingEmitter.subscribe((setting) => {
        this.compSettingSearchDetails = setting.CustomSearchFields;
        this.companySettingBrandingLogo = setting.General.BrandingLogoFilePath;
      });
    }

    if (this.userSessionService.dayendSettingDetails != undefined) {
      this.facilityDayendSetting = this.userSessionService.dayendSettingDetails;
    } else {
      this.userSessionService.dayendsettingEmitter.subscribe((setting) => {
        this.facilityDayendSetting = setting;
      });
    }

    if (this.userSessionService.facilityLateAndLienSetting != undefined) {
      this.facilityLateAndLienSetting = this.userSessionService.facilityLateAndLienSetting;
    } else {
      this.userSessionService.facilityLateAndLienEmitter.subscribe((setting) => {
        this.facilityLateAndLienSetting = setting;
      });
    }
    if (this.userSessionService.newslist) {
      this.newslist = this.userSessionService.newslist;
    } else {
      this.userSessionService.newsListEmitter.subscribe((setting) => {
        this.newslist = setting;
      });
    }

    this.userSessionService.dayEndEmitter.subscribe((dayEnd) => {
      if (dayEnd && dayEnd === false) {
        if (this.tempRouter.navigationId === 1) {
          this.onclickSwitchStore();
        }
      }
    });
    this.userRightQuickRental();
    this.getMarketingLicenseDetails();
    this.getnewsSubject.pipe(debounceTime(600)).subscribe(event => {
      this.getnews(event);
    });
  }
  getFacilitylevellogo() {

    this.generalService.getFacilitylevellogo(this.lastAccessedFacility).subscribe((response: any) => {
      this.facilityLevelLogo = response.UrlPath;
    })
  }

  getMarketingLicenseDetails() {
    this.dashboardService.getMarketingLicenseDetails().subscribe((response: any) => {
      if (response) {
        this.isEnableCampaignTracker = response.EnableCampaignTracker;
        this.isEnableCallTracker = response.EnableCallTracker;
      }
    }, err => {
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isStopLoader'] !== undefined) {
      if (this.isStopLoader === true) {
        this.isStopLoader = false;
        this.setLoaderIcon(false);
      }
    }
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  GetSMSIntervalInMinute() {
    if (!this.sub || this.sub == undefined) {
      this.getsmscount();
      const source = Observable.interval(this.receiveSMSInterval * 60 * 1000);
      this.sub = source.subscribe(val => this.getsmscount());
    }
  }

  GetPhoneSystemType() {
    if (this.enableRingCentralWidget && (this.isESignature == 'false' || this.isESignature === undefined)) {
      if (this.userSessionService.defaultPhoneSystem) {
        const phoneSystem = this.userSessionService.defaultPhoneSystem.PhoneSystemId;
        if (phoneSystem) {
          if (phoneSystem == 467) {
            this.loadRingCentralWidget();
          }
        }
      }
    } else {
      const ele = document.getElementById('rc-widget');
      if (ele) {
        ele.remove();
      }
    }
  }

  ngAfterViewInit() {
    if (this.userSessionService.userSessionData) {
      this.userSessionStores = this.userSessionService.userSessionData.StorageFacilities;
      if (this.userSessionService.userSessionData.StoreGroupUsers.length > 0) {
        let stores = this.userSessionService.userSessionData.StoreGroupUsers.map(sg => sg.StorageFacilities);
        stores.forEach(as => {
          as.forEach(s => {
            let store = this.userSessionStores.find(st => st.Id == s.Id)
            if (store == null || store == undefined) {
              this.userSessionStores.push(s)
            }
          });
        })
      }
      this.lastAccessedFacility = this.userSessionService.userSessionData.LastAccessedStoreId;
      if (this.isAdmin === true) {
        this.switchStoreOption = false;
      } else if (this.userSessionService.isCallcenterAgent === true) {
        this.switchStoreOption = false;
        this.lastAccessedFacility = 0;
        this.locationObj = { Id: this.lastAccessedFacility, Name: '' };
        this.storeNameChange.next(this.locationObj);
        this.storeChange.emit(this.locationObj);
      } else if (this.userSessionService.userSessionData.StorageFacilities.length < 1) {
        this.switchStoreOption = false;
      } else {
        this.switchStoreOption = true;
      }
    }
  }

  StoreChanged(data) {
    if (data) {
      if (this.userSessionStores.length) {
        this.lastAccessedFacility = +data;
        const obj = this.userSessionStores.find(o => o.Id === parseInt(data));
        if (obj) {
          this.defaultStoreName = obj.Name;
        }
        this.getFacilitylevellogo();
        this.storeNameChange.next({ Id: data, Name: this.defaultStoreName });
        this.storeChange.emit({ Id: data, Name: this.defaultStoreName });
        this.userSessionService.getDayendSettings(this.lastAccessedFacility);
        this.userSessionService.getFacilityLateAndLienSettings(this.lastAccessedFacility);
      }
    }
  }

  loadRingCentralWidget() {
    // Add the RingCentral Web Widget
    if (environment.ringcentralWidgetURL && this.userSessionService.isScreenPopupTab == false) {
      const rcs = document.createElement('script');
      rcs.src = environment.ringcentralWidgetURL;
      const rcs0 = document.getElementsByTagName('script')[0];
      rcs0.parentNode.insertBefore(rcs, rcs0);
    }
  }

  showMsgDetail(id) {
    this.MessageList = false;
    this.MessageDetail = true;
    if (this.smsLists.find(o => o.Id === id)) {
      this.tenantname = this.smsLists.find(o => o.Id === id).TenantName;
      this.tenantnumber = this.smsLists.find(o => o.Id === id).FromNumber;
      this.tenantid = this.smsLists.find(o => o.Id === id).TenantId;
      this.smsfacid = this.smsLists.find(o => o.Id === id).SMSFacilityId;
      this.leaseNo = this.smsLists.find(o => o.Id === id).LeaseNumber;
      this.facilityId = this.smsLists.find(o => o.Id === id).FacilityId;
      this.reservationNumber = this.smsLists.find(o => o.Id === id).ReservationNumber;
      this.reservationFacilityId = this.smsLists.find(o => o.Id === id).ReservationFacilityId;
      this.inquiryNumber = this.smsLists.find(o => o.Id === id).InquiryNumber;
      this.inquiryFacilityId = this.smsLists.find(o => o.Id === id).InquiryFacilityId;
      this.transactionTypeId = this.smsLists.find(o => o.Id === id).TransactionTypeId;
      this.sendSMSAlert = this.smsLists.find(o => o.Id === id).SendSMSAlert;
    }
    this.getSmsLogs();
    this.markMessageAsRead(id);
  }

  HideMsgDetail() {
    this.MessageList = true;
    this.MessageDetail = false;
  }

  openModal(template: TemplateRef<any>) {
    if (!this.modalRef) {
      this.modalRef = this.modalService.show(template, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
    }
  }

  openSwitchstoreModal(template: TemplateRef<any>) {
    this.openModal(template);
  }

  onclickSwitchStore() {
    this.SwitchStoreComponent.openSwitchstoreModal();
    this.removeNotify_pop();
  }

  getnewslist(facilityID, Startdate) {
    this.dashboardService.getNewslistForOp(facilityID, Startdate).subscribe((response: any) => {
      this.newslist = response;
      this.userSessionService.newslist = this.newslist;
    });
  }

  getnews(NewsID) {
    this.Newsservice.getNewsdetailsForOp(NewsID).subscribe((response: INewsModel) => {
      this.newsInfo = response;
      this.newscontent = this.newsInfo.Contents;
      this.rteValue = this.newscontent;
      this.modalRef = this.modalService.show(this.newspop, { class: 'modal-dialog modal-dialog-centered modal-xxl', backdrop: 'static', keyboard: false });
    });
  }

  openFullscreen() {
    this.isFullScreen = true;
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  closeFullscreen() {
    this.isFullScreen = false;
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }

  // Notification popup------------
  showPopupNotification(cls) {
    (document.querySelector('.topHearder') as HTMLElement).classList.toggle(cls);
    const notClslist = (document.querySelector('.head_notification') as HTMLElement);
    if (notClslist) {
      (document.querySelector('.head_notification') as HTMLElement).classList.toggle('selected');
    } (document.querySelector('.containerForRemoveNotify') as HTMLElement).classList.toggle('Open');
    (document.querySelector('.topHearder') as HTMLElement).classList.remove('message_toggle');
    (document.querySelector('.topHearder') as HTMLElement).classList.remove('profile_toggle');
    // (document.querySelector('.head_msg') as HTMLElement).classList.remove('selected');
    if (this.lastAccessedFacility != 0 && this.isAdmin === false) {
      (document.querySelector('.head_msg') as HTMLElement).classList.remove('selected');
    }
  }

  // Message popup------------
  showPopupMessage(cls) {
    this.getSMSIncomingLists();
    this.getLettersAndNoticesTemplateList();
    this.MessageDetail = false;
    this.MessageList = true;
    (document.querySelector('.topHearder') as HTMLElement).classList.toggle(cls);
    // (document.querySelector('.head_msg') as HTMLElement).classList.toggle('selected');
    if (this.lastAccessedFacility != 0 && this.isAdmin === false) {
      (document.querySelector('.head_msg') as HTMLElement).classList.toggle('selected');
    }
    (document.querySelector('.containerForRemoveNotify') as HTMLElement).classList.toggle('Open');
    (document.querySelector('.topHearder') as HTMLElement).classList.remove('notification_toggle');
    (document.querySelector('.topHearder') as HTMLElement).classList.remove('profile_toggle');
    const notClslist = (document.querySelector('.head_notification') as HTMLElement);
    if (notClslist) {
      (document.querySelector('.head_notification') as HTMLElement).classList.remove('selected');
    }
  }

  // Profile popup------------
  ProfileMenu(cls) {
    (document.querySelector('.topHearder') as HTMLElement).classList.toggle(cls);
    (document.querySelector('.containerForRemoveNotify') as HTMLElement).classList.toggle('Open');
    (document.querySelector('.topHearder') as HTMLElement).classList.remove('notification_toggle');
    (document.querySelector('.topHearder') as HTMLElement).classList.remove('message_toggle');
    if (this.lastAccessedFacility != 0 && this.isAdmin === false) {
      (document.querySelector('.head_msg') as HTMLElement).classList.remove('selected');
    }
    // (document.querySelector('.head_msg') as HTMLElement).classList.remove('selected');
    const notClslist = (document.querySelector('.head_notification') as HTMLElement);
    if (notClslist) {
      (document.querySelector('.head_notification') as HTMLElement).classList.remove('selected');
    }
  }

  removeNotify_pop() {
    if ((document.querySelector('.topHearder') as HTMLElement).classList.contains('notification_toggle')) {
      this.showPopupNotification('notification_toggle');
      (document.querySelector('.containerForRemoveNotify') as HTMLElement).classList.remove('Open');
      // (document.querySelector('.head_msg') as HTMLElement).classList.remove('selected');
      if (this.lastAccessedFacility != 0 && this.isAdmin === false) {
        (document.querySelector('.head_msg') as HTMLElement).classList.remove('selected');
      }
    }

    if ((document.querySelector('.topHearder') as HTMLElement).classList.contains('message_toggle')) {
      this.showPopupMessage('message_toggle');
      (document.querySelector('.containerForRemoveNotify') as HTMLElement).classList.remove('Open');
      const notClslist = (document.querySelector('.head_notification') as HTMLElement);
      if (notClslist) {
        (document.querySelector('.head_notification') as HTMLElement).classList.remove('selected');
      }
    }

    if ((document.querySelector('.topHearder') as HTMLElement).classList.contains('profile_toggle')) {
      this.showPopupMessage('profile_toggle');
      (document.querySelector('.containerForRemoveNotify') as HTMLElement).classList.remove('Open');
      // (document.querySelector('.head_msg') as HTMLElement).classList.remove('selected');
      if (this.lastAccessedFacility != 0 && this.isAdmin === false) {
        (document.querySelector('.head_msg') as HTMLElement).classList.remove('selected');
      }
      const notClslist = (document.querySelector('.head_notification') as HTMLElement);
      if (notClslist) {
        (document.querySelector('.head_notification') as HTMLElement).classList.remove('selected');
      }
    }
  }

  // for sms and chat
  getsmscount() {
    if (this.lastAccessedFacility !== 0) {
      this.twoWayService.GetsmsCountservice(this.lastAccessedFacility).subscribe((response: any) => {
        this.smsCount = response;
      });
    }
  }

  getSmsLogs() {
    const obj = {
      FacilityId: this.lastAccessedFacility,
      TenantId: this.tenantid,
      FilterText: 'all',
    };
    this.twoWayService.getSmsLogs(obj).subscribe((response: ISendSMSLogsResponse) => {
      this.logs = response;
      this.logs.forEach(element => {
          element.FacilityDateTime = element.FacilityDateTime?.replace('Z', '');
      });
      if (this.logs) {
        this.filteredLogs = this.logs;
      }
      this.scrollToBottom();
    });
  }

  getSMSIncomingLists() {
    this.twoWayService.GetIncomingSMSList(this.lastAccessedFacility).subscribe((response: IRecieveSMSListResponse) => {
      this.smsLists = response;
    });
  }

  scrollToBottom() {
    this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
  }

  getDashboardDetails(facilityID: number, leaseNo: number, tenantId: number) {
    this.customerService.GetDashboardDetails(facilityID, leaseNo, tenantId).subscribe((response: IDashboardDetails) => {
      this.customerDashboardDetails = response;
      this.countryCode = this.customerDashboardDetails.CustomerInfoList.CountryCode;
    });
  }

  getLastTenDigitNumber(id): string {
    const lastTen = id.substr(id.length - 10);
    return lastTen;
  }

  sendTheSms() {
    this.fullphonenumber = '+1' + this.getLastTenDigitNumber(this.tenantnumber);
    if (this.smstext === undefined || this.smstext.trim() === '' || this.smstext === null) {
      this.toastr.error('Text cannot be blank', 'Failure', this.toasterConfig);
    } else {
      const phoneNumberArr = [];
      phoneNumberArr.push(this.fullphonenumber);
      const Messages = [];
      const singleMessage = {
        FromPhoneNumber: null,
        ToPhoneNumberList: phoneNumberArr,  // give tenant number
        Message: this.smstext,
        TenantPhoneNumber: null,
        MessageStatus: null,
        ErrorCode: null,
      };
      Messages.push(singleMessage);
      const Fobj = {
        LocationId: this.smsfacid,
        AccountID: null,
        Token: null,
        ServiceId: 0,
        LeaseNumber: this.leaseNo? this.leaseNo : null,
        FacilityId: this.smsfacid,
        ReservationNumber: this.reservationNumber? this.reservationNumber : null,
        ReservationFacilityId: this.reservationFacilityId? this.reservationFacilityId: null,
        InquiryNumber: this.inquiryNumber? this.inquiryNumber : null,
        InquiryFacilityId: this.inquiryFacilityId?  this.inquiryFacilityId : null,
        TenantId: this.tenantid,
        TransactionTypeId: this.leaseNo? ETransactionTypes.Move_In : this.reservationNumber? ETransactionTypes.Reservation : this.inquiryNumber? ETransactionTypes.Inquiry : this.transactionTypeId,
        SentSuccessfully: true,
        SMSCampaignId: null,
        SMSList: Messages,
      };
      this.twoWayService.SendSms(Fobj).subscribe((response: ISendSmsResponse) => {
        if (response.Success === true) {
          this.smstext = '';
          this.selectedTypeId = null;
          this.getSmsLogs();
        } else {
          this.selectedTypeId = null;
          this.smstext = '';
          this.toastr.error('Failed to Send SMS', 'Failure', this.toasterConfig);
        }
      });
    }
  }

  markMessageAsRead(smsid) {
    const Smsobj = {
      FacilityId: this.lastAccessedFacility,
      SmsId: smsid
    };
    this.twoWayService.markAsread(Smsobj).subscribe((response: IMarkAsReadResponse) => {
      if (response.Success === true) {
        this.getsmscount();
        this.getSMSIncomingLists();
      }
    });
  }

  initiateDelConv(id) {
    this.toDeleteOneList = id;
    this.modalRef = this.modalService.show(this.deleteConv, { class: 'modal-md modal-dialog-centered' });
  }

  deleteConversation() {
    const delObj = {
      FacilityId: this.lastAccessedFacility,
      SmsId: this.toDeleteOneList
    };
    this.twoWayService.deleteMess(delObj).subscribe((response: IMarkAsReadResponse) => {
      if (response.Success === true) {
        this.getsmscount();
        this.getSMSIncomingLists();
      }
    });
    this.getSMSIncomingLists();
    this.modalRef.hide();
  }

  cancelDelete() {
    this.modalRef.hide();
  }

  goToEsignaturePage() {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        eSignatureNewTab: true,
      }
    };
    this.router.navigate(['/eSignature'], navigationExtras);
  }

  goToMarketingDashboard() {
    this.router.navigate(['/marketingd']);
  }

  groupBy(xs, f) {
    return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), []);
  }

  userRightQuickRental() {
    let inqCreateRight = false;
    let inqEditRight = false;
    let resCreateRight = false;
    let resEditRight = false;
    let rentCreateRight = false;
    if (this.generalService.UserPermissions != undefined) {
      let prospectPermission = this.generalService.getUserPermissionsForModule(EUserFunctions.Prospect);
      let rentalPermission = this.generalService.getUserPermissionsForModule(EUserFunctions.Rental);
      inqCreateRight = prospectPermission.CreateRight;
      inqEditRight = prospectPermission.EditRight;
      resCreateRight = rentalPermission.CreateRight;
      resEditRight = rentalPermission.EditRight;
      rentCreateRight = this.generalService.getUserPermissionsForModule(EUserFunctions.Reservation).CreateRight;
      this.viewRightTenantMapping = this.generalService.getUserPermissionsForModule(EUserFunctions['Tenant Mapping']).ViewRight;

      if (inqCreateRight || inqEditRight || resCreateRight || resEditRight || rentCreateRight) {
        this.permissionQuickStart = true;
      }
    } else {
      this.generalService.userGroupPermissions.subscribe(response => {
        let usergrouppermissionList = response;
        const inquiryPermissions1 = usergrouppermissionList.Functions.find(fun => fun.FunctionId == EUserFunctions.Prospect);
        const rentalPermissions = usergrouppermissionList.Functions.find(fun => fun.FunctionId == EUserFunctions.Rental);
        const reservationPermissions = usergrouppermissionList.Functions.find(fun => fun.FunctionId == EUserFunctions.Reservation);
        const tenantMappingPermissions = usergrouppermissionList.Functions.find(fun => fun.FunctionId == EUserFunctions['Tenant Mapping']);
        if (inquiryPermissions1 && inquiryPermissions1.UserGroupRights) {
          inqCreateRight = inquiryPermissions1.UserGroupRights.CreateRight;
          inqEditRight = inquiryPermissions1.UserGroupRights.EditRight;
        }
        if (rentalPermissions && rentalPermissions.UserGroupRights) {
          resCreateRight = rentalPermissions.UserGroupRights.CreateRight;
          resEditRight = rentalPermissions.UserGroupRights.EditRight;
        }
        if (reservationPermissions && reservationPermissions.UserGroupRights) {
          rentCreateRight = reservationPermissions.UserGroupRights.CreateRight;
        }
        if (tenantMappingPermissions && tenantMappingPermissions.UserGroupRights) {
          this.viewRightTenantMapping = tenantMappingPermissions.UserGroupRights.ViewRight;
        }
        if (inqCreateRight || inqEditRight || resCreateRight || resEditRight || rentCreateRight) {
          this.permissionQuickStart = true;
        }
      });
    }
  }

  getnewsInfo() {
    if (!this.isAdmin && this.newslist != undefined && !this.isQuickStart) {
      return true;
    }
    return false;
  }

  onClickOperationsMode() {
    this.generalService.IsAdmin=false;
    this.router.navigate(['/dashboard']);
    this.userSessionService.mailServerSettings.getMailServerSettingDetailsForOp().subscribe((response: IMailServerSettingModel) => {
      this.userSessionService.mailServerSetting = response;
      if (response && response.ActivateSmsService && response.SmsOption == 356) {
        this.GetSMSIntervalInMinute();
      }
    });
  }

  getLettersAndNoticesTemplateList() {
    this.letterAndNoticesService.GetLettersAndNoticesTemplateListByTypeIdAndFacilityId(202,this.lastAccessedFacility).subscribe((response: any) => {
      this.lettertypelist = response;
    });
  }

  onLetterTypeChange(event){
    var letterandnoticeid = parseInt(event);
    this.selectedTypeId = this.lettertypelist.find(o => o.Id === letterandnoticeid).Id;
    this.getLettersAndNoticesByPassingID(this.selectedTypeId);
  }

  getLettersAndNoticesByPassingID(typeId) {
    this.letterAndNoticesService.getLettersAndNoticesByIdForOp(typeId).subscribe((response: any) => {
      this.LetterTemplateDetails = response;
      this.smstext = this.LetterTemplateDetails.SMSContents;
    });
  }
}
